import { Segment, SegmentedControl } from "@mezo-org/mezo-clay"

type StepIndicatorProps = { numberOfSteps: number; currentStep: number }

export default function StepIndicator({
  numberOfSteps,
  currentStep,
}: StepIndicatorProps) {
  const activeKey = `.$${currentStep}`

  return (
    <SegmentedControl
      activeKey={activeKey}
      overrides={{
        Root: {
          style: ({ $theme }) => ({
            marginTop: $theme.sizing.scale600,
            backgroundColor: "transparent",
            paddingLeft: 0,
            paddingRight: 0,
          }),
        },
        SegmentList: {
          style: { minHeight: "unset", backgroundColor: "transparent" },
        },
        Active: {
          style: { backgroundColor: "black" },
        },
      }}
    >
      {Array.from({ length: numberOfSteps }).map((_, index) => {
        const isStepCompleted = currentStep > index
        return (
          <Segment
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            overrides={{
              Segment: {
                style: ({ $theme, $isActive }) => ({
                  cursor: "auto",
                  marginRight: "8px",
                  height: "8px",
                  padding: 0,
                  backgroundColor:
                    $isActive || isStepCompleted
                      ? "black"
                      : $theme.colors.borderOpaque,
                  ":hover": {
                    boxShadow: "unset",
                  },
                }),
                props: { $as: "div" },
              },
            }}
          />
        )
      })}
    </SegmentedControl>
  )
}
